
export class DischargeSummaryExtraDetails {
  isAdmittingDoctor: boolean = false;
  isTreatingDoctor: boolean = true;
  admittingDetails: any = {
    admittingDoctor: '',
    admittingDoctorId: '',
    admittingDoctorSpeciality: '',
    admittingDoctorSpecialityId: '',
    qualification: ''
  };
  treatingDetails: any = {
    currentTreatingDoctor: '',
    currentTreatingDoctorId: '',
    currentTreatingDoctorSpeciality: '',
    currentTreatingDoctorSpecialityId: '',
    qualification: ''
  };
  additionalDoctorDetails: any = [];
  dischargeType: string = '';
  expectedDischargeDateAndTime: number = 0;
  deathDateTime: any ="";
  printHeader: string = '';
}

export class DischargeSummaryExtraParameters {
  admittingDoctorsDischargeSummary: any = [];
  treatingDoctorsDischargeSummary: any = [];
  additionalDoctorsDischargeSummary: any = [];
  additionalDropdown: any = [];
  printHeaders: any = [];
}

export class DefinalizeDetails {
  reason: string = '';
  id: string = '';
  isDefinalize: boolean = false;
}